import { FC, ReactNode, useEffect, useState } from 'react'
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'
import { TAMANHO_MAXIMO_MOTIVO_ELEGIBILIDADE } from '@/types/elegibilidade'

/**
 * P2 — diálogo das decisões do ADMIN sobre elegibilidade (sobrepor impedimento, alterar rota).
 * Motivo SEMPRE obrigatório (≤500, 422 `MOTIVO_OBRIGATORIO` no servidor); o autor vem do token.
 */
export const DialogoMotivoElegibilidade: FC<{
  aberto: boolean
  titulo: string
  rotuloConfirmar: string
  /** Conteúdo acima do motivo (resumo do impedimento, escolha da rota). */
  children?: ReactNode
  /** Desabilita o confirmar mesmo com motivo (ex.: rota não escolhida). */
  podeConfirmar?: boolean
  erro?: string | null
  onConfirmar: (motivo: string) => Promise<void> | void
  onFechar: () => void
}> = ({ aberto, titulo, rotuloConfirmar, children, podeConfirmar = true, erro, onConfirmar, onFechar }) => {
  const [motivo, setMotivo] = useState('')
  const [enviando, setEnviando] = useState(false)

  useEffect(() => {
    if (aberto) setMotivo('')
  }, [aberto])

  const confirmar = async () => {
    if (!motivo.trim()) return
    setEnviando(true)
    try {
      await onConfirmar(motivo.trim())
    } finally {
      setEnviando(false)
    }
  }

  return (
    <Dialog open={aberto} onClose={() => !enviando && onFechar()} maxWidth="sm" fullWidth>
      <DialogTitle>{titulo}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {children}
          <TextField
            label="Motivo"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            required
            fullWidth
            multiline
            minRows={2}
            disabled={enviando}
            inputProps={{ maxLength: TAMANHO_MAXIMO_MOTIVO_ELEGIBILIDADE }}
            helperText={`Obrigatório — fica na linha do tempo e na auditoria da reserva (${motivo.length}/${TAMANHO_MAXIMO_MOTIVO_ELEGIBILIDADE}).`}
          />
          {erro && <Alert severity="error">{erro}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar} disabled={enviando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => void confirmar()}
          disabled={!motivo.trim() || !podeConfirmar || enviando}
          startIcon={enviando ? <CircularProgress size={14} color="inherit" /> : undefined}
        >
          {rotuloConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogoMotivoElegibilidade
